module.exports = "\r\n  <div *ngIf=\"pageData\" >\r\n    <div >Page Data is: {{pageData.Name}}</div>\r\n\r\n    Upload:\r\n    <p-fileUpload name=\"myfile[]\" url=\"http://localhost:35257/api/Page1/upload\" [accept]=\"text/xml\" auto=\"auto\"></p-fileUpload>\r\n\r\n  </div>\r\n       \r\n     \r\n \r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/page1/page1.component.html
// module id = ../../../../../src/app/page1/page1.component.html
// module chunks = main